import { useCallback } from 'react';
import { MediaPlayerError } from '@yi/core';

import { nr } from '~/src/common/newRelic';
import { useCurrentUser } from '~/src/common/user';

import { useMediaPlayer } from '../MediaPlayerProvider';

export function useReportMediaPlaybackError() {
  const { mediaId } = useMediaPlayer();
  const { currentUser } = useCurrentUser();
  const userId = currentUser?.id ? currentUser?.id : '';

  const report = useCallback(
    (errorDetails: Error | string) => {
      const error =
        errorDetails instanceof Error ? errorDetails : new MediaPlayerError(errorDetails);
      nr.noticeError(error, { media_id: mediaId, user_id: userId });
      throw error;
    },
    [mediaId, userId],
  );
  return report;
}
